<template>
  <div class="ListEquipamentos">
    <HeaderPage>
      <el-button v-if="$can('1|2|4|6')" style="height: 44px; margin-left: 1rem" @click="
        () => {
          $router.push({ name: 'records.equipment.create' });
        }
      " native-type="submit">Adicionar</el-button>
      <el-dropdown v-if="$can('1|2|4|6')" trigger="click" @command="handleAction">
        <el-button type="text" icon="el-icon-more" class="el-dropdown-link"></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-upload" command="openModalImportar">Importar</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </HeaderPage>
    <el-card v-loading="loadingPage">
      <FilterBox v-on:filter="listDados" :currentPage="listData.meta ? listData.meta.pagination.current_page : 1" />
      <TableSimple :list-data="listData" @paginationClick="paginationClick">
        <el-table-column prop="serial_number" label="Nº Serial" />
        <el-table-column prop="equipment_model.name" label="Modelo" />
        <el-table-column v-if="!$can('2')" prop="marketplace.person.name_store" label="Marketplace" />
        <el-table-column prop="status" label="Status" width="160">
          <template slot-scope="scope">
            <tagStatus :status="scope.row.status" />
          </template>
        </el-table-column>
        <el-table-column width="55">
          <template slot-scope="scope">
            <el-button type="text" @click="
              () => {
                $router.push({
                  name: 'records.equipment.edit',
                  params: { id: scope.row.id },
                });
              }
            ">
              <EditIcon size="1.2x" style="padding: 0 7px"></EditIcon>
            </el-button>
          </template>
        </el-table-column>
      </TableSimple>
    </el-card>

    <el-dialog title="Importar - Enviar Arquivo" :visible.sync="openModalImportar" width="30%">
      <el-upload :action="urlPostImage.url" :headers="urlPostImage.headers" :auto-upload="true" :file-list="fileList"
        :on-success="handleSuccess" :on-error="handleError">
        <el-button type="primary">Selecionar Arquivo</el-button>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openModalImportar = false">Fechar</el-button>
        <el-button @click="getDownload()" size="sm">Download Template</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import { mapGetters } from "vuex";
import { api as configs } from "@/app/config";
import TableSimple from "@/app/components/Table/TableSimple";
import { EditIcon } from "vue-feather-icons";
import FilterBox from "@/app/domains/Records/components/Equipamentos/_filterBox";
import {
  getEquipamentos,
  postImportArquivo,
} from "@/app/domains/Records/services";
import tagStatus from "@/app/components/Table/TagStatus";

export default {
  name: "ListEquipamentos",
  components: {
    HeaderPage,
    TableSimple,
    EditIcon,
    FilterBox,
    tagStatus,
  },
  data() {
    return {
      loadingPage: false,
      listData: {},
      openModalImportar: false,
      fileList: [],
      query: '?page=1'
    };
  },
  methods: {
    async handleAction(act) {
      if (act === "openModalImportar") {
        this.fileList = [];
        this.openModalImportar = true;
      }
    },
    handleSuccess(response, file, fileList) {

      if (response.error) {
        this.$message({
          showClose: true,
          message: response.message,
          type: "error",
        });
      } else {
        this.$message({
          showClose: true,
          message: "Arquivo enviado com sucesso!",
          type: "success",
        });
      }
    },
    handleError(error, file, fileList) {
      let data = JSON.parse(error.message);
      this.$message({
        showClose: true,
        message: data.message ? data.message : "Erro ao carregar arquivo!",
        type: "error",
      });
    },
    getDownload() {
      window.open('https://apiportal.posportal.com.br/template_import_equipment.xlsx', '_blank')
    },
    init() {
      this.listDados();
    },
    paginationClick(arg) {
      const newQueryString = this.query
        .replace(/[?&](page|per_page)=[^&]+/gi, "") // Remove as informações de "page" e "per_page"
        .replace(/^[?&]/, "");
      this.listDados(
        "?" + newQueryString + "&page=" + arg.page + `&per_page=${arg.meta.per_page}`
      );
    },
    async listDados(query = "") {
      this.loadingPage = true;
      this.query = query;
      try {
        let response = await getEquipamentos(query);
        this.listData = response.data;
      } catch (e) {
        this.$message({
          showClose: true,
          message: "Erro ao carregar listagem",
          type: "error",
        });
      } finally {
        this.loadingPage = false;
      }
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters("Auth", ["getToken"]),
    autoUploadImage: function () {
      return false;
    },
    urlPostImage: function () {
      return {
        url: `${configs.baseUrl}import/equipment`,
        headers: {
          Authorization: "Bearer " + this.getToken,
        },
      };
    },
  },
};
</script>

<style scoped></style>
